import { useDispatch, useSelector } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as action from '../actions/practiceFields';
import { RootState } from '../reducers';
import { PracticeFieldsState } from '../../components/Shared/PracticeAreas/types';

export const usePracticeFieldsState = () => {
  const { ...practiceFields } = useSelector((state: RootState) => state.practiceFields) as PracticeFieldsState;
  return { ...practiceFields };
};

export const usePracticeFieldsDispatch = () => {
  const dispatch = useDispatch();
  return { ...bindActionCreators( { ...action }, dispatch) };
};